import { EnvUtil } from './env-util';

export const getSFDCLinkForEdit = salesforceQuoteId => {
  return EnvUtil.sfdcBaseUrl + salesforceQuoteId;
};

export const getSFDCLinkForClose = salesforceId =>
  EnvUtil.sfdcOppUrl.replace(':salesforceId', salesforceId);
